<template>
  <CCol>
    <CRow>
      <h4>Reactivations</h4>
    </CRow>
    <CRow>
      <RDataTable
        :items="data"
        :fields="columns"
        :table-props="{ sorter: false }"
        class="reactivations-table"
      >
        <template #property="{ item }">
          <td>
            <CLink :href="getPropertyLink(item)" target="_blank">
              {{ item.property.name }}
            </CLink>
          </td>
        </template>
        <template #company="{ item }">
          <td>
            <CLink :href="getCompanyLink(item)" target="_blank">
              {{ item.company.human_name }}
            </CLink>
          </td>
        </template>
        <template #timestamp="{ item }">
          <td>
            {{ format(new Date(item.timestamp), 'MMM d, yyyy - h:mm a') }}
          </td>
        </template>
        <template #reactivation_date="{ item }">
          <td>
            {{ item.reactivation_date ? format(new Date(item.reactivation_date), 'MMM d, yyyy') : 'Unknown' }}
          </td>
        </template>
      </RDataTable>
    </CRow>
  </CCol>
</template>

<script>
import { format } from 'date-fns'

import { RDataTable } from '@/components/tables'

const adminUrl = process.env.VUE_APP_ADMIN_URL

export default {
  name: 'ReactivationsTable',
  components: { RDataTable },
  props: {
    data: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      columns: [
        {
          key: 'property',
          label: 'Property'
        },
        {
          key: 'company',
          label: 'Company'
        },
        {
          key: 'timestamp',
          label: 'Time Changed'
        },
        {
          key: 'modified_by',
          label: 'Changed By'
        },
        {
          key: 'product',
          label: 'Product'
        },
        {
          key: 'reactivation_date',
          label: 'Reactivation Date'
        }
      ]
    }
  },
  created () {
    this.format = format
  },
  methods: {
    /**
     * Generate the admin link for the property edit page
     *
     * @param {Object} row - table row item
     * @returns {Object}
     */
    getPropertyLink (row) {
      return `${adminUrl}companies/${row.company.id}/properties/${row.property.id}`
    },
    /**
     * Generate the admin link for the company summary page
     *
     * @param {Object} row - table row item
     * @returns {Object}
     */
    getCompanyLink (row) {
      return `${adminUrl}companies/${row.company.id}`
    }
  }
}
</script>

<style lang="scss" scoped>
.reactivations-table {
  width: 100%;
}
</style>
